import React from 'react';
import Tooltip from './Tooltip';
import { recursiveModelColor } from '../../utils/recursiveModelColor';

// Puce de couleur d'un modèle récursif. Rendue à l'identique dans l'arbre des
// sections (panel gauche) et dans le bandeau de contexte (panel droit) : c'est
// le repère commun aux deux vues (cf. utils/recursiveModelColor.js).
const RecursiveModelDot = ({ modelName, label, size = 8 }) => {
  const color = recursiveModelColor(modelName);
  if (!color) return null;

  const dot = (
    <span
      style={{
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        display: 'inline-block',
      }}
    />
  );

  if (!label) return dot;
  return (
    <Tooltip title={label} placement='top' mouseEnterDelay={0.3}>
      {/* Wrapper inline-flex : le Tooltip d'antd pose ses handlers sur l'enfant,
          un span de 8px sans boîte propre est difficile à survoler. */}
      <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>{dot}</span>
    </Tooltip>
  );
};

export default RecursiveModelDot;
